// extracted by mini-css-extract-plugin
export default {"container":"add-color-button-module__container--KD5kK","icon":"add-color-button-module__icon--RGyxX"};